import { makeStyles } from "tss-react/mui";

import { tabletBreakpoint } from "shared/theme/defaultTheme";

export const useNotFoundErrorStyles = makeStyles()(theme => ({
    content: {
        maxWidth: "100%",
    },

    title: {
        marginTop: theme.spacing(1),
    },

    description: {
        marginTop: theme.spacing(2),

        [theme.breakpoints.down(tabletBreakpoint)]: {
            marginBottom: theme.spacing(2),
        },
    },
}));
